module.exports = __webpack_public_path__ + "img/18_21.04fa6898.png";